import MobileNav from '../plugins/mobileNavPlugin';
import AccessibilityNav from '../plugins/AccessibilityNavPlugin';
import Collapsible from '../plugins/CollapsiblePlugin';

const menuHolder = document.querySelector('body');
const mobileNav = new MobileNav(menuHolder, {
  onShow() {
    window.scrollTo({top: 0, behavior: "smooth"});
    mobileNav.btnOpeners.forEach((btn) => {
      btn.setAttribute('aria-expanded', 'true');
    });
    document.addEventListener('keydown', handleKeyPress);
  },
  onHide() {
    mobileNav.btnOpeners.forEach((btn) => {
      btn.setAttribute('aria-expanded', 'false');
    });
    mobileNav.btnOpeners[0].focus();
    document.removeEventListener('keydown', handleKeyPress);
  },
});

function initMobileNav() {
  mobileNav.init();
}

const searchHolder = document.querySelector('html');
const headerSearch = new MobileNav(searchHolder, {
  activeClass: 'search-active',
  btnOpenerSelector: '.js-search-opener',
  event: 'click',
  hideOnClickOutside: true,
  outSideSelector: '.header',
  onShow() {
    window.scrollTo({top: 0, behavior: "smooth"});
    headerSearch.btnOpeners.forEach((btn) => {
      btn.setAttribute('aria-expanded', 'true');
    });
    setTimeout(() => {
      document.querySelector('.header-search__input').focus();
    }, 100)
  },
});

function initSearch() {
  headerSearch.init();
}

function initAccessibilityNav() {
	document.querySelectorAll('.menubar').forEach(nav => {
		if (nav.childElementCount > 0) {
            new AccessibilityNav(nav, '1024px');
        }
	});
}

function initCollapsible() {
  document.querySelectorAll('.menubar li').forEach(item => {
    if (item.querySelector(':scope > ul') || item.querySelector(':scope > div')) {
      const openClose = new Collapsible({
        holder: item,
        opener: '> .submenu-opener',
        slide: '> ul',
        breakpoint: '1024px' // '0' is default value
      });
    }
  });
}

function handleKeyPress(event) {
  const keys = getKeyboardFocusableElements(mobileNav.outSideContainer);
  const firstItem = keys.slice(0)[0];
  const lastItem = keys.slice(-1)[0];
  let currentItem = document.activeElement;

  if (event.shiftKey && event.keyCode == 9) {
    if (currentItem == firstItem) {
      setTimeout(() => {
        lastItem.focus()
      }, 50)
      event.preventDefault();
    }
  } else if (event.key == "Tab") {
    if (currentItem == lastItem) {
      setTimeout(() => {
        firstItem.focus()
      }, 50)
      event.preventDefault();
    }
  } else if (event.key == "Escape") {
    mobileNav.hide();
  }
}

function getKeyboardFocusableElements(element = document) {
  return [
    ...element.querySelectorAll(
      'a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])',
    ),
  ].filter(
    el => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'),
  )
}

function initHeaderHeight() {
  let header = document.getElementById('header');

  if (!header) return;

  function setHeaderHeight() {
    let headerHeight = header.offsetHeight;
    document.querySelector(':root').style.setProperty('--header-height', headerHeight + 'px');
    document.querySelector(':root').style.setProperty('--page-width', window.innerWidth);
  }

  setHeaderHeight();

  window.addEventListener('resize', setHeaderHeight);
}

function initNavAnchor() {
  const navLinks = document.querySelectorAll('.main-nav__link');
  if (navLinks.length == 0) return;

  navLinks.forEach(navLink => {
    anchorLink(navLink);
  })

  function anchorLink(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      let navbarHeight = 0;
      if (window.innerWidth >= 1024) {
        navbarHeight = document.querySelector('.main-nav').offsetHeight;
      }
      let element = document.querySelector(link.getAttribute('href'));
      if (!element) return;
      const y = element.getBoundingClientRect().top + window.scrollY - navbarHeight;
      window.scrollTo({top: y, behavior: 'smooth'});
      mobileNav.hide();
    })
  }
}

export {initMobileNav, initAccessibilityNav, initCollapsible, initHeaderHeight, initSearch}
